import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { pricing } from '../data/tables';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, TOTAL_VALUE } from '../data/config';
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="bg-paper" data-id="element-159" data-mp="2jjw8ddgrhoiy">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-160" data-mp="1vu1ucskphtx4">
        <div className="mx-auto max-w-[640px] border border-brass bg-white p-6 shadow-raised rounded-sharp sm:p-7 md:p-10" data-id="element-161" data-mp="1vublwkleg94x">
          <h2 id="pricing-heading" className="text-center font-serif text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-162" data-mp="25s7ub4mycpzc">
            {pricing.heading}
          </h2>
          <p className="mt-3 text-center text-[16px] leading-[1.6] text-slate" data-id="element-163" data-mp="3h6lcptyxsd7z">
            {pricing.subheading}
          </p>

          <div className="mt-10 grid gap-8 border-y border-brass/30 py-9 md:grid-cols-2" data-id="element-164" data-mp="3c7s3idqon8dm">
            <div data-id="element-165" data-mp="3vyx9y77z6ciq">
              <h3 className="font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-166" data-mp="3w1jgq4n1knzw">
                {pricing.volumesLabel}
              </h3>
              <ul className="mt-4 space-y-2.5" data-id="element-167" data-mp="9rp6jagm8fpc">
                {pricing.volumeList.map(item => <li key={item} className="flex gap-2.5" data-id="element-168" data-mp="erldnikm0n94">
                    <CheckIcon className="mt-[4px] h-3.5 w-3.5 shrink-0 text-brass" strokeWidth={2.5} aria-hidden="true" data-id="element-169" data-mp="eoz8tqp3slul" />
                    <span className="text-[15px] leading-[1.5] text-ink" data-id="element-170" data-mp="3n753e7m2nnjf">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-171" data-mp="3rzeonac8rzfd">
              <h3 className="font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-172" data-mp="3rzy9ayta11x3">
                {pricing.bonusesLabel}
              </h3>
              <ul className="mt-4 space-y-2.5" data-id="element-173" data-mp="2zgr7g60d94jk">
                {pricing.bonusList.map(item => <li key={item} className="flex gap-2.5" data-id="element-174" data-mp="2rg33w246hwmx">
                    <span aria-hidden="true" className="mt-[1px] text-[12px] leading-[1.5]" data-id="element-175" data-mp="2reicgld5utta">
                      🎁
                    </span>
                    <span className="text-[15px] leading-[1.5] text-ink" data-id="element-176" data-mp="315mphfja04lh">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-9 text-center" data-id="element-177" data-mp="28hh1mjwxdzhf">
            <p className="font-mono text-[11px] uppercase tracking-label text-slate" data-id="element-178" data-mp="28iin7ibki4de">
              Total value: {TOTAL_VALUE}
            </p>
            <p className="mt-2 font-mono text-[13px] uppercase tracking-label text-brick line-through" data-id="element-179" data-mp="2ifwvuvr91ov5">
              Regular price: {REGULAR_PRICE}
            </p>
            <p className="mt-4 font-mono text-[56px] font-medium leading-none text-ink md:text-[72px]" data-id="element-180" data-mp="2dfsez4mfis4e">
              {PRICE}
            </p>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-label text-slate" data-id="element-181" data-mp="3ows27ltx6grk">USD</p>
          </div>

          <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-182" data-mp="a42rp0cwqnv">
            {pricing.badges.map(badge => <li key={badge} className="border border-brass/40 bg-sage px-3 py-1.5 font-mono text-[10px] uppercase tracking-label text-ink rounded-sharp" data-id="element-183" data-mp="5a9q4szlfr05">
                {badge}
              </li>)}
          </ul>

          <p className="mt-5 text-center font-mono text-[10px] uppercase leading-[1.5] tracking-label text-slate/70" data-id="element-184" data-mp="j0d8h8vcr0kb">
            {pricing.disclaimer}
          </p>

          <p className="mt-7 border-t border-brass/25 pt-7 text-[15px] leading-[1.6] text-slate" data-id="element-185" data-mp="o1sq0qybmoxy">
            {pricing.reasonWhy}
          </p>

          <div className="mt-8" data-id="element-186" data-mp="e93i261zbt7d">
            <CtaButton href={CHECKOUT_URL} fullWidth data-id="element-187" data-mp="e8bzpwxe7rz1">
              {pricing.cta}
            </CtaButton>
            <TrustRow align="center" className="mt-4" data-id="element-188" data-mp="11xmr4nsusa0i" />
          </div>
        </div>
      </div>
    </section>;
}